(ns minorodata.components.shortcut.core
  (:require [reagent.core :as reagent]
            [ui.shortcut]
            ["react-hotkeys-hook" :refer [useHotkeys]]))


(defn shortcut-hooks [props]
  (let [{:keys [classes title value shortcuts inline]} (js->clj props :keywordize-keys true)
        shortcuts  (js->clj shortcuts :keywordize-keys true)]

    (mapv (fn [{:keys [shortcut handler options]}]
            (useHotkeys shortcut handler (clj->js options)))
          shortcuts)

    (reagent/as-element
     [ui.shortcut/keycap {:class ["border-0! bg-kleene-selected-background w-5" (when inline "ml-1") (:kbd classes)]
                          :title title}
      value])))



(defn shortcut [props]
  [:> shortcut-hooks props])
